import { NgModule } from '@angular/core';
import { ArticleComponent } from './article.component';
import { ArticleService } from './article.service';
import { ArticleRoutingModule } from './article-routing.module';
import { SharedModule } from '../shared/shared.module';
import { MatTabsModule } from '@angular/material/tabs';
import { MatPaginatorModule } from '@angular/material/paginator';

@NgModule({
  imports: [ArticleRoutingModule, SharedModule, MatTabsModule, MatPaginatorModule],
  declarations: [ArticleComponent],
  exports: [ArticleComponent],
  providers: [ArticleService]
})
export class ArticleModule { }
